import { apiSlice } from '../../../api/apiSlice';
import { SCORECARD_PAYOUT_CRITERIA } from '../../../constants';

export const ScorecardPayoutCriteriaSlice = apiSlice.injectEndpoints({
    endpoints: (builder: any) => ({
        getScorecardPayoutCriteria: builder.query({
            query: (arg: any) => {
                const { year, month, scorecardVersionId } = arg;
                return {
                    url: SCORECARD_PAYOUT_CRITERIA,
                    params: { year, month, scorecardVersionId },
                };
            },
        }),
    }),
});

export const { useGetScorecardPayoutCriteriaQuery } = ScorecardPayoutCriteriaSlice;
